import styled from 'styled-components';
import { SkeletonProps, SkeletonColors } from './skeleton.types';
import { MLBTheme } from '../../style/theme.types';
import COLORS from '../../style/universal.color';

const { transparent } = COLORS;
const getRadius = ({ isCircle = false, borderRadius = '' }: { isCircle?: boolean; borderRadius?: number | string }) =>
  isCircle ? '50%' : `${getPx(borderRadius)}`;

const getBackgroundColor = (theme: MLBTheme, animation: boolean | undefined) => {
  const type: string = theme && theme.dark ? 'dark' : 'primary';
  const bg: string = SkeletonColors[type as keyof typeof SkeletonColors].main;
  const bgHl: string = SkeletonColors[type as keyof typeof SkeletonColors].highlight;
  return animation
    ? `
    linear-gradient(90deg, ${bg}, ${bgHl}, ${bg});
    background-color: ${bg};
  `
    : `
    ${transparent};
    background-color: ${bg};
  `;
};

const isLoadingOff = (isLoading: boolean | undefined): boolean =>
  typeof isLoading !== 'undefined' && isLoading == false;

const getPx = (val: string | number): string | number => (val ? (typeof val === 'string' ? val : `${val}px`) : 'auto');

export const StyledBaseSkeleton = styled.div<SkeletonProps>`
  height: ${({ height = '' }) => getPx(height)};
  width: ${({ width = '' }) => getPx(width)};

  background: ${({ isLoading, theme = {}, animation }) =>
    typeof isLoading === 'undefined' || isLoading ? getBackgroundColor(theme, animation) : transparent};
  background-size: ${({ isLoading }) => (isLoadingOff(isLoading) ? 'auto auto' : '200px 100%')};

  border-radius: ${(props) => getRadius(props)};
  margin-bottom: ${({ margin }) => (margin ? getPx(margin) : 0)};

  background-repeat: no-repeat;
  &:last-child {
    margin-bottom: ${({ margin }) => (margin ? getPx(margin) : 0)};
  }
  &.is-loading {
    > span {
      display: none;
    }
  }

  animation: ${({ animation, isLoading }) =>
    isLoadingOff(isLoading) || !animation ? 'none' : 'pulse 1.2s infinite ease-in-out'};
  @keyframes pulse {
    0% {
      background-position: -200px 0;
    }
    100% {
      background-position: calc(200px + 100%) 0;
    }
  }
`;
